import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import LoadingDots from '@alltrails/denali/components/LoadingDots';
import styles from './styles/styles.module.scss';

// https://www.figma.com/file/YubcZX08vX2JgZf6jlKglQ/Google-pay-with-Recurly?node-id=227%3A31309&t=oWm862mnaTwhiJ4D-4

type Props = {
  fullscreen?: boolean;
};

function LoadingOverlay({ fullscreen = false }: Props) {
  return (
    <div className={classNames(styles.container, { [styles.fullscreen]: fullscreen })}>
      <div className={styles.contentContainer}>
        <LoadingDots />
        <h2 className={styles.heading}>
          <FormattedMessage defaultMessage="Hold tight! We're processing your payment." />
        </h2>
      </div>
    </div>
  );
}

export default LoadingOverlay;
